import script from "./NotificationChannels.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationChannels.vue?vue&type=script&setup=true&lang=js"

import "./NotificationChannels.vue?vue&type=style&index=0&id=ed65e9f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed65e9f4"]])

export default __exports__